/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createOkFromDiscriminatorValue, createOrderTypeResponseFromDiscriminatorValue, serializeAddOrderTypeRequest, serializeDeleteOrderTypeRequest, serializeEditOrderTypeRequest, serializeOk, serializeOrderTypeResponse, type AddOrderTypeRequest, type DeleteOrderTypeRequest, type EditOrderTypeRequest, type ErrorResponse, type InternalErrorResponse, type Ok, type OrderTypeResponse } from '../../../models/index.js';
// @ts-ignore
import { ClearRequestBuilderRequestsMetadata, type ClearRequestBuilder } from './clear/index.js';
// @ts-ignore
import { ReorderRequestBuilderRequestsMetadata, type ReorderRequestBuilder } from './reorder/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/order-types
 */
export interface OrderTypesRequestBuilder extends BaseRequestBuilder<OrderTypesRequestBuilder> {
    /**
     * The clear property
     */
    get clear(): ClearRequestBuilder;
    /**
     * The reorder property
     */
    get reorder(): ReorderRequestBuilder;
    /**
     * Delete an Order Type from an organization
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Ok>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     */
     delete(body: DeleteOrderTypeRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Ok | undefined>;
    /**
     * Adds an order type the organization's reps and customers can choose from. The name is the organization's own — the kind is required and tells the platform how to treat orders written against it. Many names may map to one kind. Adding a name that already exists is a no-op and returns the existing order type unchanged.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<OrderTypeResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: AddOrderTypeRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<OrderTypeResponse | undefined>;
    /**
     * Updates an existing Order Type, looked up by its Slug. The slug itself never changes, so orders already written against this type keep pointing at it. Supply Kind to re-map the type to a different platform kind, or omit it to leave the kind untouched — re-mapping affects only orders written from now on, never the kind already stamped on existing orders.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<OrderTypeResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: EditOrderTypeRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<OrderTypeResponse | undefined>;
    /**
     * Delete an Order Type from an organization
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(body: DeleteOrderTypeRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Adds an order type the organization's reps and customers can choose from. The name is the organization's own — the kind is required and tells the platform how to treat orders written against it. Many names may map to one kind. Adding a name that already exists is a no-op and returns the existing order type unchanged.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AddOrderTypeRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Updates an existing Order Type, looked up by its Slug. The slug itself never changes, so orders already written against this type keep pointing at it. Supply Kind to re-map the type to a different platform kind, or omit it to leave the kind untouched — re-mapping affects only orders written from now on, never the kind already stamped on existing orders.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: EditOrderTypeRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const OrderTypesRequestBuilderUriTemplate = "{+baseurl}/api/organizations/order-types";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const OrderTypesRequestBuilderNavigationMetadata: Record<Exclude<keyof OrderTypesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    clear: {
        requestsMetadata: ClearRequestBuilderRequestsMetadata,
    },
    reorder: {
        requestsMetadata: ReorderRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const OrderTypesRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: OrderTypesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOkFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDeleteOrderTypeRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    post: {
        uriTemplate: OrderTypesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOrderTypeResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAddOrderTypeRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    put: {
        uriTemplate: OrderTypesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOrderTypeResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeEditOrderTypeRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
